import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import { INoteModel } from '@src/slide/domain/ui-model/element-modeles/Interface/note-model.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { IConnectorModel } from '@src/slide/domain/ui-model/element-modeles/Interface/connector-model.interface';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { IEmptyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/empty-model.interface';
import { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import * as shapeValues from '@src/slide/application/service/menu-manager/menu-values/shape';
import * as connectorValues from '@src/slide/application/service/menu-manager/menu-values/connector';
import * as pictureValues from '@src/slide/application/service/menu-manager/menu-values/picture';
import * as emptyValues from '@src/slide/application/service/menu-manager/menu-values/empty';
import * as tableValues from '@src/slide/application/service/menu-manager/menu-values/table';
import * as chartValues from '@src/slide/application/service/menu-manager/menu-values/chart';
import { isImageConfigurableForShapeImageFill } from '@src/slide/domain/ui-model/element-modeles/property/fill/image-fill/is-image-configurable';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import { getAllChildModels } from '@src/slide/domain/ui-model/element-modeles/property/utils/merge-property';
import { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';

export const elementModelsTypes = [
    UIModelType.SHAPE,
    UIModelType.CONNECTOR,
    UIModelType.IMAGE,
    UIModelType.EMPTY,
    UIModelType.TABLE,
    UIModelType.CHART,
];

export function getElementMenuValues(model?: IBaseModel | INoteModel): { [key: string]: any } {
    if (!model) {
        return {};
    }
    const modelType = model.type;
    // 形状
    if ([UIModelType.SHAPE].includes(modelType)) {
        return shapeValues.getMenuValues(model as IShapeModel);
    }
    // 连接线
    if ([UIModelType.CONNECTOR].includes(modelType)) {
        return connectorValues.getMenuValues(model as IConnectorModel);
    }
    // 图片
    if ([UIModelType.IMAGE].includes(modelType)) {
        return pictureValues.getMenuValues(model as IPictureModel);
    }
    // 空白
    if ([UIModelType.EMPTY].includes(modelType)) {
        return emptyValues.getMenuValues(model as IEmptyModel);
    }
    // 表格
    if ([UIModelType.TABLE].includes(modelType)) {
        return tableValues.getMenuValues(model as ITableModel);
    }
    // 图表
    if ([UIModelType.CHART].includes(modelType)) {
        return chartValues.getMenuValues(model as IChartModel);
    }

    return {};
}

/**
 * 获取多选元素/组合中的所有图片或者图片填充的形状
 * @param selectedModels
 * @returns
 */
export function getAllImage(model: IElementBaseModel | IMultiplyModel): IElementBaseModel[]  {
    const selectedModels = getAllChildModels(model);
    return selectedModels.filter((model) => {
        if (model.type === UIModelType.IMAGE) {
            return (model as IPictureModel).isImage();
        }
        return isImageConfigurableForShapeImageFill(model);
    });
}

